export const CategoriesContext = 'category'
